<template>
  <div class="card-b4">
    <v-list dense>
      <v-list-item class="card-b4--header">
        <v-list-item-content>
          <v-list-item-title class="text-h6" v-text="model.ds_oferta"></v-list-item-title>
        </v-list-item-content>

        <v-list-item-content class="card-b4--header_logo">
          <v-img :src="model.ds_path_logo" :aspect-ratio="3" :alt="model.nm_pessoa_oferta"></v-img>
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="card-b4--branch">
        <v-list-item-subtitle v-text="model.ds_ramo"></v-list-item-subtitle>
      </v-list-item>

      <v-list-item
        :class="[
          'risk-level',
          model.cd_ocorrencia_vinculo == 1 && 'risk-error',
          model.cd_ocorrencia_vinculo == 2 && 'risk-warning'
        ]"
        v-if="model.cd_ocorrencia_vinculo == 1 || model.cd_ocorrencia_vinculo == 2"
      >
        <v-tooltip
          right
          :color="(model.cd_ocorrencia_vinculo == 1 && 'red') || (model.cd_ocorrencia_vinculo == 2 && 'amber')"
        >
          <template v-slot:activator="{ on, attrs }">
            <span
              :data-has-tooltip="model.ds_hint_ocorrencia_vinculo ? 'true' : 'false'"
              :data-tooltip="model.ds_hint_ocorrencia_vinculo"
              v-on="on"
              v-bind="attrs"
            ></span>
          </template>
          <span>{{ model.ds_hint_ocorrencia_vinculo }}</span>
        </v-tooltip>
      </v-list-item>

      <v-list-item class="card-b4-content-coin">
        <v-list-item-content class="card-b4-coin">
          <v-list-item-title>Moeda</v-list-item-title>
          <v-list-item-subtitle v-text="model.nm_moeda"></v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-content class="card-b4-prices">
          <v-list-item-title v-text="`I.S: ${model.vl_is}`"></v-list-item-title>
          <v-list-item-title v-text="`Prêmio: ${model.vl_premio}`"></v-list-item-title>
          <v-list-item-title v-text="`Comissão Min: ${model.pe_comissao} %`"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item class="line-border-bottom">
        <v-list-item-content class="text-center">
          <v-list-item-title class="text-center">Min</v-list-item-title>
          <v-list-item-subtitle v-text="`% Cessão: ${model.pe_cessao_minimo}`"></v-list-item-subtitle>
          <v-list-item-subtitle v-text="`I.S: ${model.vl_is_minimo}`"></v-list-item-subtitle>
          <v-list-item-subtitle v-text="`Prêmio: ${model.vl_premio_minimo}`"></v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content class="text-center">
          <v-list-item-title class="text-center">Max</v-list-item-title>
          <v-list-item-subtitle v-text="`% Cessão: ${model.pe_cessao_maximo}`"></v-list-item-subtitle>
          <v-list-item-subtitle v-text="`I.S: ${model.vl_is_maximo}`"></v-list-item-subtitle>
          <v-list-item-subtitle v-text="`Prêmio: ${model.vl_premio_maximo}`"></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item class="card-b4-footer line-border-bottom">
        <v-list-item-content class="small">
          <v-list-item-title>Vigência</v-list-item-title>
        </v-list-item-content>

        <v-list-item-content class="align-right">
          <v-list-item-subtitle v-text="model.ds_vigencia"></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item class="card-b4-footer">
        <v-list-item-content class="small">
          <v-list-item-title class="text-active" v-text="model.nm_status"></v-list-item-title>
          <div class="status">
            <span class="green" v-if="model.nm_status == 'Ativa'"></span>
            <span class="red" v-if="model.nm_status == 'Cancelada'"></span>
            <span class="red" v-if="model.nm_status == 'Encerrada'"></span>
            <span class="yellow" v-if="model.nm_status == 'Expirada'"></span>
            <span class="blue" v-if="model.nm_status == 'Em Análise'"></span>
            <span class="grey" v-if="model.nm_status == 'Negociada'"></span>
            <span class="black" v-if="model.nm_status == 'Emitida'"></span>
          </div>
        </v-list-item-content>

        <v-list-item-content class="align-right">
          <v-list-item-title>
            <i4proCountdown v-if="model.ds_data_expirar" :deadline="new Date(model.ds_data_expirar)" />
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
export default {
  components: {
    i4proCountdown: () => import('@/components/countdown/i4pro-countdown')
  },

  props: {
    model: { type: Object, default: () => ({}) }
  }
};
</script>

<style lang="scss" scoped>
.card-b4 {
  padding-top: 25px;

  .card-b4--header {
    height: auto;

    .v-list-item__content {
      padding: 0;
    }

    .card-b4--header_logo {
      max-width: 80px;
    }
  }

  .card-b4-content-coin {
    padding: 35px 0;

    .card-b4-coin {
      max-width: 70px;
    }
  }

  .line-border-bottom {
    border-bottom: 1px solid;
    margin-bottom: 10px;
    padding-bottom: 10px;
  }

  .card-b4-footer {
    .small {
      max-width: 100px;
    }

    .align-right {
      text-align: right;
    }
  }

  .card-b4--branch {
    margin-top: 8px;
    .v-list-item__subtitle {
      font-size: 0.9rem;
    }
  }

  .card-b4-prices {
    text-align: right;
    .v-list-item__title {
      font-size: 1rem;
    }
  }

  .v-list {
    padding-bottom: 0;
  }

  .v-list-item {
    padding-left: 10px;
    padding-right: 10px;
    min-height: auto;
  }

  .risk-level {
    position: absolute;
    left: -10px;
    top: 7px;
    width: 100%;
    display: flex;

    span {
      height: 15px;
      width: 20px;
      position: relative;
      background-color: #000;

      &:before,
      &:after {
        content: '';
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 0;
        position: absolute;
        right: -7px;
        border-top: 7px solid;
        border-right: 7px solid transparent;
        border-left: 7px solid transparent;
      }

      &:before {
        top: -1px;
        transform: rotate(135deg);
      }

      &:after {
        bottom: -1px;
        transform: rotate(45deg);
      }
    }

    &.risk-error {
      span {
        background-color: var(--v-error-base);

        &:before,
        &:after {
          border-top-color: var(--v-error-base);
        }
      }
    }

    &.risk-warning {
      span {
        background-color: var(--v-warning-lighten2);

        &:before,
        &:after {
          border-top-color: var(--v-warning-lighten2);
        }
      }
    }
  }

  .text-active {
    height: 25px;
  }

  .status {
    span {
      width: 10px;
      height: 10px;
      border-radius: 100%;
      display: flex;
    }
  }
}

.theme--light {
  &.line-border-bottom {
    border-bottom-color: #e5e5e5;
  }
}

.theme--dark {
  &.line-border-bottom {
    border-bottom-color: #656363;
  }
}
</style>
